import { uniq } from 'lodash';
import { useMemo } from 'react';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { useLegacyAllowanceHistoricalProposal } from '~/data/proposals/useGetLegacyHistoricalProposals';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { isRoleHRAdmin } from '~/services/Permissions';

import { useAllowanceProposalColumns } from '../../common';
import {
  AllowanceProposalWorkflowTable,
  ProposalsHistoryTableLayout,
} from '../components';

export const AllowanceProposalHistoryTable = () => {
  const roles = useLoggedInUserRoles();
  const isHRAdmin = isRoleHRAdmin(roles);
  const loggedInId = useLoggedInEmployeeId();
  const { selectedEmployeeId: employeeId } = useSelectedEmployeeId();
  const { data } = useLegacyAllowanceHistoricalProposal({
    employeeId,
  });

  const { rows, employmentIds } = useMemo(() => {
    const rows =
      loggedInId === employeeId && !isHRAdmin
        ? data.filter((item) => item.fAllowanceProposalStatus !== 'FAILED')
        : data;

    return { rows, employmentIds: uniq(rows.map((r) => r.fEmplId)) };
  }, [data, loggedInId, employeeId, isHRAdmin]);

  const columns = useAllowanceProposalColumns({ employmentIds });

  return (
    <ProposalsHistoryTableLayout
      rows={rows}
      columns={columns}
      employeeId={employeeId}
      proposalWorkflowTable={AllowanceProposalWorkflowTable}
    />
  );
};
